import MenuSection from "../MenuSection";
import React from "react";
import RegisterOrDepositMenuItem from "./RegisterOrDepositMenuItem";

const TopMenuSection = () => (
  <MenuSection>
    <RegisterOrDepositMenuItem />
  </MenuSection>
);

export default React.memo(TopMenuSection);
